@if (showPage()) {
  @if (totalErrors > 0) {
    <div>
      <div id="inline-warning-left" class="ot-message ot-message--is-warning">
        <div class="ot-message__banner">
          <p class="ot-message__item">
            {{totalErrorsStr}}
          </p>
        </div>
      </div>
    </div>
  }
  <div [ngClass]="{'scroll-area': totalErrors == 0, 'scroll-area-banner' : totalErrors > 0}">
    <ng-scrollbar>
      @if (product !== undefined) {
        <div id class="ot-section">
          <div class="ot-row ot-level">
            <div class="ot-level__left"><h2>{{getProductName(product, true)}}</h2></div>
            <div class="ot-btn-group ot-level__right">
              @if (isOnlineMode) {
                <button id="download-button" role="button" otsc-button color="primary" i18n-title title="Download" [disabled]="isDownloadDisabled()" (click)="onDownload()">Download</button>
              }
              <button id="cancel-button" role="button" otsc-button color="secondary" i18n-title title="Cancel" [routerLink]="['..']">Cancel</button>
            </div>
          </div>
          @if (showOSDropDown()) {
            <div class="ot-row">
              <div class="ot-form-control" style="margin-bottom: 0px;">
                <label for="downloadOSSelector">Please select the desired operating system for download.</label>
                <div class="ot-select">
                  <select id="downloadOSSelector" (change)="onSelectOS($event)">
                    <option [value]="0">Select an operating system</option>
                    @for (option of operatingSystems | orderBy:'asc':'displayName'; track option) {
                      <option [value]="option.uid">{{option.displayName}}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          }
          @if (totalSelected > 0) {
            <div class="ot-row">
              <p style="margin: 0px;">{{totalSizeStr}}</p>
            </div>
          }
        </div>
      }
      <app-datatable [identifier]="'downloads-table'" [cols]="cols" [rows]="rows" [isloading]="isLoading" [showcheckboxes]="isOnlineMode" [sortdata]="true" [scroll]="false"
      (selectAllClickEvent)="onSelectAll($event)" (checkboxchangeevent)="calculateTotals(rows)" [isSortable]="false" [persistErrorCtrls]="true"></app-datatable>
    </ng-scrollbar>
  </div>
} @else {
  <div id="catalog-download-loading" class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter">
      </div>
    </div>
    <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
  </div>
}

